import { render, staticRenderFns } from "./PublishWorks.vue?vue&type=template&id=6cff5e60&scoped=true"
import script from "./PublishWorks.vue?vue&type=script&lang=js"
export * from "./PublishWorks.vue?vue&type=script&lang=js"
import style0 from "./PublishWorks.vue?vue&type=style&index=0&id=6cff5e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff5e60",
  null
  
)

export default component.exports